import { useFormContext } from 'react-hook-form';
import { GroupType, OptionType } from '../../../../CommonComponents/OPL/Select/BaseSelect/types';
import { OwnerModelDTO } from '../../../../Profile/Accounts/api/useAccountsQuery';
import {
  AccountType,
  AccountTypeOptionsDTO,
} from '../../../../Profile/Accounts/api/useAccountsOptionsQuery';
import { OwnerTypeDTO } from '../../../../ProfileOPL/OtherAssets/OtherAssets.meta';

interface Params {
  accountTypes: AccountTypeOptionsDTO[];
  selectedAccountType: AccountType;
  accountOwners: any;
}

export const useAccountOwnership = ({
  accountTypes,
  selectedAccountType,
  accountOwners,
}: Params) => {
  const accountOptions = accountTypes.find(option => option.AccountType === selectedAccountType);

  const hasJointOptions = accountOptions?.AllowsJointOwnership;
  const hasTrustOptions = accountOptions?.AllowsTrustOwnership;

  const getOptions = () => {
    const IndividualOwnerOptions = {
      People: accountOwners.People.filter(({ Name }) => Name !== 'Joint'),
      Trusts: null,
    };

    const OwnerOptions = {
      People: accountOwners.People.filter(({ Name }) => Name !== 'Joint'),
      Trusts: [...accountOwners.Trusts],
    };

    if (!hasJointOptions && !hasTrustOptions) {
      return IndividualOwnerOptions;
    }

    if (hasJointOptions) {
      return accountOwners;
    }

    if (!hasTrustOptions) {
      return IndividualOwnerOptions;
    }

    return OwnerOptions;
  };

  const ownerOptions = getOptions();

  return {
    accountOwnersOptions: Object.keys(ownerOptions).reduce(
      (accumulator, groupKey) =>
        accumulator.concat(
          (ownerOptions[groupKey] || []).map(accountOwner => ({
            label: accountOwner.Name,
            value: accountOwner.Id,
            groupId: groupKey.toLowerCase(),
          })),
        ),
      [],
    ) as { label: string; value: string; groupId: string }[],
    accountOwnersGroups: Object.keys(ownerOptions).map(groupKey => ({
      groupId: groupKey.toLowerCase(),
      title: groupKey,
    })),
    ownerOptions: Object.keys(ownerOptions)
      .map(key => ownerOptions[key])
      .flat()
      .filter(val => val !== null) as OwnerModelDTO[],
    allowsUnequalOwnership: accountOptions ? accountOptions.AllowsUnequalOwnership : false,
  };
};
